import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

// import _ from 'lodash';

import { ContainerBlock } from "../../styles";

import BlogList from "./blogList";
import BlogsNotFound from "./blogsNotFound";

import { useGetAllBlogs } from "../../apiHooks/home";
import { useCheckAnalytics } from "../../apiHooks/common";

import LoaderCircle from "../loader";

const Blogs: React.FC<any> = () => {
  // fetch after parsing url
  const [load, setLoad] = useState(false);

  let location = useLocation();
  const parsedSearch = queryString.parse(location.search);

  const { data, isLoading } = useGetAllBlogs(
    parsedSearch,
    load,
    location.search
  );

  useEffect(() => {
    setLoad(true);
  }, []);
  const [title, setTitle] = useState("");
  // set head > title
  useEffect(() => {
    const querytitle =
      parsedSearch.category || parsedSearch.q || parsedSearch.tag;
    const newTitle = `${
      location.search.length > 2
        ? `${querytitle} - veli.Blog `
        : "Veli.Blog - ბლოგები ციფრული შოპინგის პლატფორმაზე"
    }`;
    setTitle(newTitle);
    document.title = newTitle;
  }, [location.search]);

  return (
    <>
      <ContainerBlock>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "60px 0",
            }}
          >
            <LoaderCircle />
          </div>
        ) : data?.data.results.length ? (
          <BlogList
            blogs={data.data.results}
            current={data.data.current}
            pages={data.data.total_pages}
          />
        ) : (
          <BlogsNotFound />
        )}
      </ContainerBlock>
    </>
  );
};

export default Blogs;
